import { DataWithPublicUser } from '../../../services/User/useDataWithPublicUser';
import { AuctionDto, BidDto } from '../../../services/Auction/auctionService.dto';
import { BidderDto } from './bidderTypes';
import { findWinningBid, isWinnerDetermined } from './auctionUtils';

export const convertToBidder = (data: DataWithPublicUser<BidDto>[], auction?: AuctionDto): BidderDto[] => {
  if (!auction) return [];

  const winningBid = isWinnerDetermined(auction) ? findWinningBid(auction) : null;

  return data.map(({ data: bid, user }) => ({
    ...user,
    bid,
    resigned: !!winningBid && bid.created > winningBid.created,
    winner: !!winningBid && bid.id === winningBid.id,
  }));
};
